import React, { createContext, useContext, useEffect, useState } from 'react';

const ContentLayoutContext = createContext();

export function useContentLayout() {
    const context = useContext(ContentLayoutContext);
    if (!context) {
        throw new Error('useContentLayout must be used within a ContentLayoutProvider');
    }
    return context;
}

export function ContentLayoutProvider({ children }) {
    const [layoutConfig, setLayoutConfig] = useState({
        columns: 1,
        fontSize: 12,
        isHigher: false,

    });


    const updateIsHigher = () => {
        const windowsHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight
        const isHigher = documentHeight > windowsHeight
        setLayoutConfig((prevState) => ({
            ...prevState,
            isHigher
        }));
        return isHigher

    }



    const checkColumns = () => {
        const isHigher = updateIsHigher();
        if (isHigher) {
            addColumn()
        }

    }

    layoutConfig.columns

    const addColumn = () => {
        setColumnCount(layoutConfig.columns + 1)
    }

    const removeColumn = () => {
        setColumnCount(layoutConfig.columns - 1)
    }

    const addFontsize = () => {
        setFontSize(layoutConfig.fontSize + 1)
    }

    const removeFontsize = () => {
        setFontSize(layoutConfig.fontSize - 1)
    }

    const resetFontsize = () => {
        setFontSize(12)
        // console.log('reset font');
    }
    const resetColumn = () => {
        setColumnCount(1)
        //console.log('rest column')
    }

    const setColumnCount = (columns) => {
        // Limiter le nombre de colonnes à 20 maximum
        const limitedColumns = Math.min(columns, 20);
        // Mettez à jour le nombre de colonnes dans l'état.
        setLayoutConfig((prevState) => ({
            ...prevState,
            columns: limitedColumns,
        }));
    };

    const setFontSize = (fontSize) => {
        // Mettez à jour la taille de la police dans l'état.
        setLayoutConfig((prevState) => ({
            ...prevState,
            fontSize,
        }));
    };
    const checkFontsize = () => {
        const isHigher = updateIsHigher();
        if (layoutConfig.columns === 1 && layoutConfig.fontSize === 12 && !isHigher) {
            setFontSize(20)
            setColumnCount(2)
        }
        if (isHigher) {
            if (layoutConfig.columns <= 2) {
                setFontSize(20)
            } else
                if (layoutConfig.columns >= 4 && layoutConfig.columns <= 6) {
                    setFontSize(18)
                } else
                    if (layoutConfig.columns >= 6 && layoutConfig.columns <= 8) {
                        setFontSize(16)
                    }
                    else
                        if (layoutConfig.columns >= 8 && layoutConfig.columns <= 12) {
                            setFontSize(14)
                        }
                        else if (layoutConfig.columns >= 12) {
                            setFontSize(12)
                        }
        }


    }

    const changeData = () => {
        resetColumn();
        resetFontsize();
        checkFontsize()
        checkColumns()
    }

    useEffect(() => {
        checkColumns()
        checkFontsize()
        updateIsHigher()
    }, [ layoutConfig.columns, layoutConfig.fontSize])




    //console.log(layoutConfig)


    return (
        <ContentLayoutContext.Provider value={{ changeData, layoutConfig, addColumn, removeColumn, resetColumn, addFontsize, removeFontsize, checkColumns, checkFontsize, updateIsHigher, resetFontsize }}>
            {children}
        </ContentLayoutContext.Provider>
    );
}
